import Logo from '../logos/weisstechniksim';

export default Logo;
